import qribft from "@/assets/qr_IBFT.json";
import qr_mrcht_acc_info from "@/assets/qr_mrcht_acc_info_tmp.json";
import qribft_subtab from "@/assets/qr_ibft_subtab.json"


/**
 * qrstring -> 값으로 변환
 * @param {*} val
 * @param {*} paramObj
 */
// IBFT에 대해서만 QR String이 들어올 경우 어떤 키값을 가지고 그 Value가 무엇인지
// 추출해주는 역할만 함
export default class IBFTs {
    qrString = "";
    dataObjArr = [];
    isNapas = false;

    getIsNapas(){
        return this.isNapas;
    }

    qrHashMap = {};
    constructor(qrString){
        this.qrString = qrString
    }

    getQRHashmap(){
        return this.qrHashMap;
    }

    QRtoValue(qrString) {

        var qrStr = "";
        var index = 0;
        var id = "";
        var prevId = ""; // 이전 id값(현재 id값과 비교해서 더 크면 depth가 달라진 것)
        // 즉, 다른 테이블을 참조하는 것이고 조건상 ID 38인 경우, ID가 62인 경우 
        
        var len = 0;
        // HashMap1,2,3 나눠서 관리
        var ibftHashMap = new Map();
        for(let i = 0; i <= qrString.length; i++) {  
            qrStr += qrString[i];
            index += 1;
            if(index == 4){
                id = qrStr.substr(0, 2);
                len = qrStr.substr(2, 2);
                var data = "";
  
                // i는 현재 qrString의 리얼 인덱스 위치
                // index는 ID & Length를 해서 4자리 맞춰서 자르기 위한 인덱스 
                // len + i의 위치값이됨 

                // depth 변경 == 다른 테이블 참조
                data = saveIBFTValue(id, len, i, qrString, ibftHashMap, prevId);
    
                // [0] -> data object name / [1] -> Value
                ibftHashMap[data.split("/")[0]] = data.split("/")[1];
                // 길이 인덱스 조정
                i = parseInt(i) + parseInt((data.split("/")[1]).length);
                // hashmap에 넣기
                this.saveQRHashmap(data.split("/")[0], data.split("/")[1]);  
                // id = 38인 경우 qr_mrcht_acc_info 테이블 참조해야함
                if(id == "38"){
                    this.saveIBFTMerchantAccInfo(data.split("/")[0], data.split("/")[1]);
                }
                // merchant global setting
                qrStr = "";
                prevId = id;
                id = "";
                len = 0;
                index = 0;

            }
        }

    }
    /*
    *  Line 129 ~ 206
    *  saveIBFTMerchantAccInfo, IBFTMerchantAccInfoSubData (ID 38인 경우=)
    */
    // id 38일때 참조하는 테이블
    // 값 : 0010A0000007270129000697046201158110012200027300208QRIBFTTA 이게 넘어올 것임
    saveIBFTMerchantAccInfo(key, value) {
        var qrStr = "";
        var id = "";
        var len = "";
        var index = 0;
        // var prevId = "";
        var ibftSubHashMap = new Map();
        for(var i = 0; i <= value.length; i++){
            qrStr += value[i];
            index+=1;
            if(index == 4){
                id = qrStr.substr(0,2);
                len = qrStr.substr(2,2);
                var data = "";
                data = IBFTSubInfoTab(id, len, i, value, ibftSubHashMap, 1);
                // [0] -> data object name / [1] -> Value
                ibftSubHashMap[data.split("/")[0]] = data.split("/")[1];

                // NAPAS GUID 확인
                if(data.split("/")[0] == "Guid" && data.split("/")[1] == "A000000727"){
                    this.isNapas = true;
                }
                // QR push
                this.saveQRHashmap(data.split("/")[0], data.split("/")[1]);
                // 길이 인덱스 조정 
                i = parseInt(i) + parseInt((data.split("/")[1]).length); // 이쪽수정 
                
                // payment Network sepc
                if(id == "01"){
                    this.IBFTPaymentNetSpecSubTab(data.split("/")[0], data.split("/")[1]);
                } 
                // merchant global setting
                qrStr = "";
                // prevId = id;
                id = "";
                len = 0;
                index = 0;
            }
        } 
    }

        
    // ID 38인데, Payment network specific (Member banks, Payment Intermediaries) 01 or 02 일떄 
    // 01 : Key 15, value 
    // 길이 29, value : 00069704620115811001220002730
    IBFTPaymentNetSpecSubTab(key, value){
        var qrStr = "";
        var id = "";
        var len = "";
        var index = 0;
        // var prevId = "";
        var ibftSubHashMap2 = new Map();

        for(var i = 0; i < value.length; i++){
            qrStr += value[i];
            index+=1;
            if(index == 4){
                id = qrStr.substr(0,2);
                len = qrStr.substr(2,2);
                var data = "";
                data = IBFTSubInfoTab(id, len, i, value, ibftSubHashMap2, 2);
                // [0] -> data object name / [1] -> Value
                ibftSubHashMap2[data.split("/")[0]] = data.split("/")[1];
                // QR push
                this.saveQRHashmap(data.split("/")[0], data.split("/")[1]);
                // 길이 인덱스 조정
                i = parseInt(i) + parseInt((data.split("/")[1]).length);
                // payment Network sepc
                // merchant global setting
                qrStr = "";
                // prevId = id;
                id = "";
                len = 0;
                index = 0;
            }
        } 
    }

    saveQRHashmap = function(key, value){
        this.qrHashMap[key] = value;
    }

}
// 길이만큼 파라미터로 받은 문자열을 루프 돌려서 값을 합치고 Value 합쳐서 값으로 잡기
// ID 값으로 받은걸로 Data Object 적어두기 
function saveIBFTValue(id, len, i, qrString, hashmap){
   // console.log(qrString);
    var qrValue = "";
    // 전체 ID 중 들어온 id가 포함된 곳에서 data object name 뽑고 값은 위에 qrValue로 정의
    for(var elem in qribft){

        if((qribft[elem].ID).includes(id)){
            // 원래 MerchantAccInfo 이거인데, 38 = Napas인 경우 
            // ConsumerAccInfo 이걸로 변환
            // 이미 등록된 키가 있다면 넘어가기 
            // 등록된 키가 없다면 value값으로 넣을 것 
            // 11 - static, 12 - dynamic
            if(id == "38"){
                elem = "ConsumerAccInfo";      
            }
            // id값이 01인데 (이건 사실 외부에서 조건처리하면 되는거라 별도로 분기처리 안함)
            // elem -> 11 - static, 12 - dynamic
            if(hashmap.has(elem)){
                qrValue = "";   
            } else {
                qrValue = qrValue + elem + "/";
            }
            break;
        }
    }
    // 여기 추가
    var len2 = 0;
    // 앞자리가 0이면 10 미만인 값들
    if(len.substr(0,1) == "0"){
        len2 = parseInt(len.substr(1,1));
    } 
    // 10 이상일 경우는 그냥 바로 parseInt
    else {
        len2 = parseInt(len);
    }

    // value
    for(var j = i + 1; j <= (i + len2); j++){
        qrValue += qrString[j];
    }
    // 추후에 "/"로 분기처리([0] -> data object name [1] -> Value)
    console.log("haams2 :" + "len :" + len2 + "/ qrValue : " + qrValue);
    return qrValue;
}

// id 38일때 세부 내용 찾는것
function IBFTSubInfoTab(id, len, i, qrString, hashmap, depth) {
    var qrValue2 = "";
    // ID 38일때 table참조 
    if(depth == 1){
        for(var elem in qr_mrcht_acc_info){
            if((qr_mrcht_acc_info[elem].ID).includes(id)){
                // id == 02일때 SubTab (01 관련해서는 depth == 2로 넘김)
                if(id == "02") {
                    if(hashmap.has(elem)){
                        qrValue2 = "";
                    }
                    else {
                        // 고정값이라 그냥 값 픽스 > 카드면 3, 계좌면 4
                        qrValue2 += "serviceCodeSub4" + "/"
                        // qrValue2 += qrValue2 
                    }
                    break;
                } else {
                    if(hashmap.has(elem)){
                        qrValue2 = "";
                    }
                    else {
                        qrValue2 += elem +"/";
                    }
                    break;
                }                
            }
        }
    }
    else if(depth == 2){
        for(var elem2 in qribft_subtab){
            if((qribft_subtab[elem2].ID).includes(id)){
                // id = 01일때 SubTab
                if(id == "01"){
                    qrValue2 += elem2 +"/";
                } 
                // 일반적인 상황
                else {
                    if(hashmap.has(elem2)){
                        qrValue2 = "";
                    }
                    else {
                        qrValue2 += elem2 +"/";
                    }
                }
                break;
            }
        }
    }
    else {
        console.log("추가로 작업할 내용(depth가 더 깊어지면)")
    }

    var len3 = 0;
   // 앞자리가 0이면 10 미만인 값들
   if(len.substr(0,1) == "0"){
        len3 = parseInt(len.substr(1,1));
    } 
    // 10 이상일 경우는 그냥 바로 parseInt
    else {
        len3 = parseInt(len);
    }

    // value
    for(var j = i + 1; j <= (i + len3); j++){
        qrValue2 += qrString[j];
    }
    // 추후에 "/"로 분기처리([0] -> data object name [1] -> Value)
    console.log("haams3 :" + qrValue2 +" 위치: " + (i + len3));
    return qrValue2;
}